import { gql } from '@apollo/client';
import { CURRENT_SUBSCRIPTION_FRAGMENT } from '../../../lib/core/fragments/currentSubscription';

export const PLACE_SUBSCRIPTION_ORDER_FRAGMENT = gql`
  fragment PlaceSubscriptionOrder on Order {
    id
    status
    type
    amount
    vatAmount
    vatRate
    currency
    token
    completedAt
    discount {
      name
      quantityDiscounted
      totalAmountDiscounted
      partner {
        id
        name
      }
      discountAmount {
        __typename
        ... on RelativeDiscountAmount {
          amount
        }
        ... on AbsoluteDiscountAmount {
          amount
        }
      }
    }
  }
`;

export const PLACE_SUBSCRIPTION_ORDER_MUTATION = gql`
  ${PLACE_SUBSCRIPTION_ORDER_FRAGMENT}
  mutation placeSubscriptionOrderMutation($productId: ID!) {
    placeSubscriptionOrder(productId: $productId) {
      ... on Order {
        ...PlaceSubscriptionOrder
        orderLines {
          id
          type
          amount
        }
      }
      ... on SubscriptionOrderError {
        description
        errorCode
        message
      }
    }
  }
`;

export const PAY_ORDER_CHECKOUT_MUTATION = gql`
  mutation payOrderCheckoutMutation(
    $orderId: ID!
    $paths: PaymentPaths!
    $autoRenewProduct: Boolean!
    $paymentMethodType: PaymentMethodType
  ) {
    payOrderCheckout(
      orderId: $orderId
      paths: $paths
      autoRenewProduct: $autoRenewProduct
      paymentMethodType: $paymentMethodType
    ) {
      ... on CheckoutSessionStripe {
        sessionId
        publishableKey
      }
      ... on CheckoutSessionPayex {
        redirectUrl
      }
      ... on CheckoutSessionNevogate {
        redirectUrl
      }
    }
  }
`;

export const PAY_ORDER_CHARGE_MUTATION = gql`
  ${CURRENT_SUBSCRIPTION_FRAGMENT}
  mutation payOrderChargeMutation($orderId: ID!, $autoRenewProduct: Boolean!) {
    payOrderCharge(orderId: $orderId, autoRenewProduct: $autoRenewProduct) {
      __typename
      ... on ChargeCompletedSubscription {
        subscription {
          ...CurrentSubscription
        }
      }
      ... on ConfirmationSessionStripe {
        clientSecret
        paymentMethodRef
        publishableKey
        paymentDocument {
          ... on InvoiceTrip {
            token
          }
          ... on InvoiceFine {
            token
          }
          ... on Order {
            token
          }
        }
      }
      ... on ChargeCompleted {
        paymentDocument {
          ... on InvoiceTrip {
            token
          }
          ... on InvoiceFine {
            token
          }
          ... on Order {
            token
          }
        }
      }
      ... on ChargePending {
        paymentDocument {
          ... on InvoiceTrip {
            token
          }
          ... on InvoiceFine {
            token
          }
          ... on Order {
            token
          }
        }
      }
      ... on PaymentIntentError {
        description
        errorCode
        message
      }
    }
  }
`;

export const APPLY_DISCOUNT_CODE_MUTATION = gql`
  ${PLACE_SUBSCRIPTION_ORDER_FRAGMENT}
  mutation applyDiscountCodeMutation($orderId: ID!, $code: String!) {
    applyDiscountCode(orderId: $orderId, code: $code) {
      ... on Order {
        ...PlaceSubscriptionOrder
      }
      ... on DiscountCodeError {
        errorCode
        message
      }
    }
  }
`;

export const REVOKE_DISCOUNT_CODE_MUTATION = gql`
  ${PLACE_SUBSCRIPTION_ORDER_FRAGMENT}
  mutation revokeDiscountCodeMutation($orderId: ID!) {
    revokeDiscountCode(orderId: $orderId) {
      ...PlaceSubscriptionOrder
    }
  }
`;
